<convfact-userStock-form 
    [userStock]="userStock" *ngIf="userStock" 
    [errors]="errors" (onSave)="saveData($event)">
</convfact-userStock-form>